export default __webpack_public_path__ + "static/media/0.66d3a998.jpg";